import { render, staticRenderFns } from "./TabelaListaProdutos.vue?vue&type=template&id=6ea6ee36&scoped=true"
import script from "./TabelaListaProdutos.vue?vue&type=script&lang=js"
export * from "./TabelaListaProdutos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea6ee36",
  null
  
)

export default component.exports